import {
  faCalendarAlt,
  faFileAlt,
  faSearch,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { getPresciptionHistory } from "../../actions/prescriptionAction";
import Loader from "../../components/Loader";
import FeedbackPopup from "./FeedbackPopup";
import PrescriptionDetailPopup from "./PresciptionDetailPopup";
import { formatDate } from "../../utils/helper";
const PrescriptionHistory = () => {
  const prescriptionHistory = useSelector(
    (state) => state.prescription.prescriptionHistory
  );
  const [selectedDate, setSelectedDate] = useState(null);
  const [openCalendar, setOpenCalendar] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [formulaName, setFormulaName] = useState("");
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
  const [selectedPractitioner, setSelectedPractitioner] = useState("");
  const [activeItem, setActiveItem] = useState(null);
  const [activePrescriptionId, setActivePrescriptionId] = useState(0);
  const [showPrescription, setShowPrescription] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  const [filteredList, setFilteredList] = useState([]);
  useEffect(() => {
    dispatch(
      getPresciptionHistory(() => {
        setIsLoading(false);
      })
    );
  }, [dispatch]);

  useEffect(() => {
    setFilteredList(prescriptionHistory);
  }, [prescriptionHistory]);

  const optionRenderer = ({ label }, { inputValue }) => {
    const matches = match(label, inputValue);
    const parts = parse(label, matches);
    return (
      <div>
        {parts.map((part, index) => (
          <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
            {part.text}
          </span>
        ))}
      </div>
    );
  };

  useEffect(() => {
    let newList = prescriptionHistory;
    if (selectedStatus !== "") {
      newList = newList.filter(
        (x) => x.Status.toLowerCase() === selectedStatus.toLowerCase()
      );
    }
    if (selectedPractitioner !== "") {
      if (selectedPractitioner !== "All Practitioner") {
        newList = newList.filter(
          (x) => x.Practitioner_Name === selectedPractitioner
        );
      }
    }
    if (selectedDate) {
      newList = newList.filter((x) => {
        let date = formatDate(x.Created_Date);
        return date === selectedDate.toDateString();
      });
    }
    if (formulaName !== "") {
      newList = newList.filter((x) =>
        x.FORM_Custom?.toLowerCase().includes(formulaName?.toLowerCase())
      );
    }
    setFilteredList(newList);
  }, [selectedDate, selectedStatus, selectedPractitioner, formulaName]);

  const getPractitionerOptions = () => {
    let list = [
      ...new Set(prescriptionHistory.map((x) => x.Practitioner_Name)),
    ];
    let newList = [];
    list.forEach((element) => {
      if (element !== null) {
        newList.push(element);
      }
    });
    newList.sort();
    newList.unshift("All Practitioner");
    return newList;
  };
  const viewAction = (cell, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div className="action-btn-wrapper row">
          <button
            className="btn-orange btn-table "
            onClick={() => {
              setActivePrescriptionId(row.ID);
              setShowPrescription(true);
            }}
          >
            View
          </button>
        </div>
      </>
    );
  };

  const columns = [
    {
      dataField: "Created_Date",
      text: "Date Completed",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return formatDate(row.Created_Date);
      },
    },
    {
      dataField: "ID",
      text: "Prescription #",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <p>
            Prescription #{row.ID} {row.FORM_Custom && ` - ${row.FORM_Custom}`}
          </p>
        );
      },
    },
    {
      dataField: "Practitioner_Name",
      text: "Practitioner",
      sort: true,
    },
    {
      dataField: "Status",
      text: "Status",
      sort: true,
    },
    {
      dataField: "feedback",
      text: "Feedback",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <FontAwesomeIcon
            icon={faFileAlt}
            size="3x"
            onClick={() => {
              setActiveItem({
                prescriptionId: row.ID,
                feedback: row.PRSC_Patient_Feedback,
                date: row.PRSC_Patient_Feedback_Date,
                practitioner_id: row?.practitioner_id,
                practitioner_email: row?.practitioner_email,
              });
              setShowFeedbackPopup(true);
            }}
          />
        );
      },
    },

    {
      dataField: "action",
      text: "Action",
      formatter: viewAction,
    },
  ];

  return (
    <div>
      {isLoading && <Loader />}
      <h5 className="profile-title mb-1">Prescription History</h5>
      {showPrescription && (
        <PrescriptionDetailPopup
          closePopup={() => setShowPrescription(false)}
          prescriptionId={activePrescriptionId}
        />
      )}
      {prescriptionHistory.length > 0 ? (
        <>
          <div className="row mt-1 mb-3">
            <div className="col-md-3">
              <div className="date-picker">
                <div
                  className="date-picker inside"
                  onClick={() => {
                    setOpenCalendar(!openCalendar);
                  }}
                >
                  <div className="icon">
                    <FontAwesomeIcon icon={faCalendarAlt} />
                  </div>

                  <DatePicker
                    scrollableYearDropdown
                    showYearDropdown
                    showMonthDropdown
                    scrollableMonthYearDropdown
                    selected={selectedDate}
                    onChange={(date) => {
                      setSelectedDate(date);
                    }}
                    placeholderText=""
                    open={openCalendar}
                    readOnly
                    onClickOutside={() => {
                      setOpenCalendar(false);
                    }}
                  />
                </div>
                <div
                  className="icon"
                  onClick={() => {
                    setOpenCalendar(false);
                    setSelectedDate(null);
                  }}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group search" style={{ height: "44px" }}>
                <div>
                  <div className="input">
                    <input
                      value={formulaName}
                      placeholder="Search Formula Name"
                      name="search"
                      className="form-control"
                      id="search"
                      onChange={(e) => setFormulaName(e.target.value)}
                      type="text"
                    ></input>
                  </div>
                </div>
                <FontAwesomeIcon icon={faSearch} size="lg" color="gray" />
              </div>
            </div>
            <div className="col-md-3">
              <Select
                className="react-select"
                classNamePrefix="react-select"
                onChange={(e) => {
                  setSelectedPractitioner(e.value);
                }}
                value={
                  selectedPractitioner ? { label: selectedPractitioner } : ""
                }
                placeholder="All Practitioner"
                options={getPractitionerOptions().map((x) => ({
                  value: x,
                  label: x,
                }))}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  control: (props, { isDisabled }) => ({
                    ...props,
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    pointerEvents: "auto",
                  }),
                }}
                menuPortalTarget={document.body}
                menuPlacement={"bottom"}
                menuShouldScrollIntoView={false}
                formatOptionLabel={optionRenderer}
              ></Select>
            </div>
            <div className="col-md-3">
              <Select
                className="react-select"
                classNamePrefix="react-select"
                onChange={(e) => {
                  setSelectedStatus(e.value);
                }}
                value={selectedStatus ? { label: selectedStatus } : ""}
                placeholder="All Status"
                options={[
                  { label: "All Status", value: "" },
                  { label: "Ordered", value: "Ordered" },
                  { label: "Filled", value: "Filled" },
                  { label: "Shipped", value: "Shipped" },
                  { label: "Ready for Pickup", value: "Ready for Pickup" },
                  {
                    label: "Shipped to Pickup Location",
                    value: "Shipped to Pickup Location",
                  },
                  { label: "Picked Up", value: "Picked Up" },
                  { label: "Cancelled", value: "Cancelled" },
                  { label: "Expired", value: "Expired" },
                  { label: "Sent To Patient", value: "Sent To Patient" },
                ]}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  control: (props, { isDisabled }) => ({
                    ...props,
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    pointerEvents: "auto",
                  }),
                }}
                menuPortalTarget={document.body}
                menuPlacement={"bottom"}
                menuShouldScrollIntoView={false}
                formatOptionLabel={optionRenderer}
              ></Select>
            </div>
          </div>
          {showFeedbackPopup && (
            <FeedbackPopup
              closePopup={() => setShowFeedbackPopup(false)}
              previousFeedback={activeItem}
            />
          )}
          <BootstrapTable
            classes="react-bootstrap-table date"
            keyField="ID"
            columns={columns}
            data={filteredList}
            headerClasses="header-class"
          />
        </>
      ) : (
        <p className="page-desc">There are no prescription at this time</p>
      )}
    </div>
  );
};

export default PrescriptionHistory;
